import React from 'react';
import { VenueData } from '../types';

interface VenueListProps {
  venues: VenueData[];
  onEditVenue: (venue: VenueData) => void;
  onDeleteVenue: (venueId: string) => void;
}

const VenueList: React.FC<VenueListProps> = ({
  venues,
  onEditVenue,
  onDeleteVenue
}) => {
  if (venues.length === 0) {
    return (
      <div className="quick-v2-empty-state">
        <i className="fa-solid fa-location-dot"></i>
        <div>No venues added yet</div>
        <p>Click "Add Venue" to get started.</p>
      </div>
    );
  }

  return (
    <div className="quick-v2-list venue-list">
      {venues.map((venue) => (
        <div key={venue.id} className="quick-v2-row-card">
          <div className="quick-v2-row-main">
            <div className="quick-v2-icon-tile">
              <i className="fa-solid fa-location-dot"></i>
            </div>

            <div className="quick-v2-row-copy">
              <div className="quick-v2-row-title">{venue.name}</div>
              <div className="quick-v2-chip-row">
                {venue.eventDate && (
                  <span className="quick-v2-chip accent">
                    <i className="bi bi-calendar-event"></i>
                    Event Date: {venue.eventDate}
                  </span>
                )}
                {venue.latitude && venue.longitude && (
                  <span className="quick-v2-chip">
                    <i className="bi bi-geo-alt"></i>
                    {venue.latitude.toFixed(6)}, {venue.longitude.toFixed(6)}
                  </span>
                )}
              </div>
              <div className="quick-v2-row-meta">
                {venue.formattedAddress || (
                  <>
                    {venue.addressLine1 && `${venue.addressLine1}, `}
                    {venue.addressLine2 && `${venue.addressLine2}, `}
                    {venue.city && `${venue.city}, `}
                    {venue.state && `${venue.state}, `}
                    {venue.country && `${venue.country}`}
                    {venue.zipCode && ` ${venue.zipCode}`}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="quick-v2-row-actions">
            <button
              type="button"
              className="v3-btn-secondary"
              onClick={() => onEditVenue(venue)}
            >
              <i className="bi bi-pencil"></i> Edit
            </button>
            <button
              type="button"
              className="quick-v2-danger-btn"
              onClick={() => onDeleteVenue(venue.id)}
            >
              <i className="bi bi-trash"></i> Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VenueList;